import React, { Component } from 'react';
import { connect } from 'react-redux';

import ButtonStyle from 'Flow2/components/UI/Button/Button.module.scss';
import classes from './SourcefileMetadata.module.scss';
import customClasses from "Flow2/components/CustomCollections/CustomBox/CustomTableBox/CustomTableBox.module.scss";

import * as actions from 'store/actions/index';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInfo } from '@fortawesome/free-solid-svg-icons';

import Swal from 'sweetalert2';
import { FormattedMessage, injectIntl } from 'react-intl';
import Button from 'Flow2/components/UI/Button/Button';

class SourcefileMetadata extends Component{
	
	state = {
		mode: "text"
	}
    
    componentDidMount = () => { }
    
    initAlert = () => {
        const text = document.querySelector('#AlertText');
        const xml = document.querySelector('#AlertXML');
        
        text.addEventListener('click', () => this.loadContent('text'));
        xml.addEventListener('click', () => this.loadContent('xml'));
        
        this.loadContent('text');
    }
	
	loadContent = (mode) => {
		const content = document.querySelector('#AlertContent');
        const file = window.location.origin + (mode === "text" ? '/DJO_0660.metadata.txt.txt' : '/0001I3.XML');
		
        fetch(file)
			.then(response => response.text())
			.then(result => {
                this.setState({ mode: mode });
				content.innerHTML = result;
			}) 
			.catch((error) => {
			   console.log(error);
			});
	}
    
    showLocationPopup = () => {
        
		let content = this.state.mode === "xml" ? '<pre id="AlertContent"></pre>' : '<xmp id="AlertContent"></xmp>';
		
        let html = '<div class="AlertRow"><span class="AlertTab" id="AlertText">Text</span><span class="AlertTab"  id="AlertXML">XML</span></div><div class="FlowLocation">'+ content +'</div>';
        
        Swal.fire({
            title: "Sourcefile Metadata",
			width: '90%',
            showCancelButton: true,
            cancelButtonText: this.props.intl.formatMessage({ id: "common.save" }),
            confirmButtonText: this.props.intl.formatMessage({ id: "common.close" }),
            confirmButtonClass: [ButtonStyle.Button, ButtonStyle.Red].join(' '),
            cancelButtonClass: [ButtonStyle.Button, ButtonStyle.White].join(' '),
            buttonsStyling: false,
            heightAuto: false,
            html: html,
            onOpen: this.initAlert
        }).then((result) => {});
    }

    render(){
        if(!this.props.config.fileMetadata) {
            return "";
        }
        
        if(this.props.style === 'icon') {
            return(
                <>
                    <div className={customClasses.CustomTableMfIconRound} onClick={() => this.showLocationPopup()}><FontAwesomeIcon className={customClasses.CustomTableMfIcon} color="red" icon={faInfo} /></div>
                </>                   
            )
        }
        return(
            <div>
                <Button btnType="Red" clicked={() => this.showLocationPopup()}>Full EXIF Metadata</Button>
            </div>                   
        )
    }
}

const mapStateToProps = (state) => {
    return {
        config: state.ui.config
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
    }
}


export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(SourcefileMetadata));


